var map = {
	"./ada.png": 50426,
	"./ada_inverse.png": 80728,
	"./default.png": 58083,
	"./douglas.png": 16493,
	"./douglas_inverse.png": 67629,
	"./katniss.png": 87341,
	"./katniss_inverse.png": 13269,
	"./rust.png": 87687,
	"./rust_inverse.png": 29571,
	"./skilly.png": 61682,
	"./skilly_inverse.png": 64235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15186;